import React, { Component } from "react";

// reactstrap components
import { Col, Row, Progress, Button } from "reactstrap";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Sound from "react-sound";
// import getBlobDuration from "get-blob-duration";
import { getBlobURL, getFile, getDuration } from "util/blobUtils.js";
import { base, s3base } from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import MicRecorder from "mic-recorder-to-mp3";
import SpeechToText from "components/Question/Speaking/New/SpeechToText";

import "components/custom.css";

let Mp3Recorder = new MicRecorder({ bitRate: 128 });

class DescribeImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRecording: false,
      blobURL: "",
      newblobURL: "",
      isBlocked: false,
      question: "",
      secondCount: 25,
      recordCount: 0,
      recordId: 1,
      intervalId: 0,
      duration: 0,
      questionId: "",
      reset: false,
      trans: "",
      correctFlag: true,
      soundStatus: false,
      file: "",
      imageLoaded: true,
      saveTranscript: false,
      skip: true,
      skipInProgress: false,
      stopInProgress: false,
      recordingProcessed: false,
      isProcessing: false
    };
  }

  revokeBlobURL = () => {
    const { blobURL } = this.state;
    if (blobURL) {
      try {
        // Only revoke if URL exists and is a proper blob URL
        if (blobURL.startsWith("blob:")) {
          URL.revokeObjectURL(blobURL);
          console.log("🧹 Revoked blob URL instantly:", blobURL);
        }
      } catch (err) {
        console.error("⚠️ Failed to revoke blob URL:", err);
      } finally {
        // Clear from state to prevent reuse
        this.setState({ blobURL: '' });
      }
    }
  };

  componentDidMount() {
    console.log("I am describeImage from NEW")
    if (!this.props.answer && !this.props.showStartPractice) {
      var intervalId = setInterval(this.timer, 1000);
      this.setState({ intervalId: intervalId });
    }
    navigator.getUserMedia(
      { audio: true },
      () => {
        this.setState({ isBlocked: false });
      },
      () => {
        this.setState({ isBlocked: true });
      }
    );
  }

  static getDerivedStateFromProps(props, state) {
    // console.log(props, "describe image props");
    if (props.data) {
      if (
        (state.questionId && state.questionId !== props.data.id) ||
        props.restart
      ) {
        clearInterval(state.intervalId);
        clearInterval(state.recordId);
        if (state.blobURL) {
          URL.revokeObjectURL(state.blobURL);
        }
        return {
          recordCount: 0,
          isRecording: false,
          secondCount: 25,
          questionId: props.data.id,
          blobURL: "",
          reset: true,
          imageLoaded: false,
          trans: "",
          duration: 0,
          recordingProcessed: false,
          practiceStarted: !props.showStartPractice,
          isProcessing: false
        };
      } else {
        if (!state.questionId) {
          return { questionId: props.data.id, imageLoaded: false,practiceStarted: !props.showStartPractice };
        }
      }
    }
  }

  startPractice = () => {
    // Notify parent to hide the start practice button
    if (this.props.onStartPractice) {
      this.props.onStartPractice();
    }
    this.setState({
      practiceStarted: true,
    });

    // Start the countdown timer
    var intervalId = setInterval(this.timer, 1000);
    this.setState({ intervalId: intervalId });
  };
  start = () => {
    this.setState({ soundStatus: true });
  };

  handleSongFinishedPlaying = () => {
    if (this.state.isBlocked) {
      console.log("Permission Denied");
      this.setState({ soundStatus: false })
      return;
    } else {
      //       if (this.state.blobURL) {
      //   URL.revokeObjectURL(this.state.blobURL);
      //   this.state.blobURL = "";
      // }
      this.revokeBlobURL();
      Mp3Recorder = new MicRecorder({ bitRate: 128 });
      SpeechRecognition.startListening({ continuous: true, language: "en-GB" });
      Mp3Recorder.start()
        .then(() => {
          this.setState({ isRecording: true, blobURL: "", soundStatus: false, isProcessing: false });
          if (this.props.soundChecked) {
            console.log("Describe Image check", this.props.soundChecked);
            console.log(this.props?.soundChecked);
            this.props.soundChecked();
          }
        })
        .catch((e) => {
          console.error(e)
          SpeechRecognition.stopListening();
          this.setState({
            isRecording: false,
            soundStatus: false,
            blobURL: "",
            recordCount: 0,
          }, () => {
            // Submit empty data on error to allow navigation
            const data_to_send = {
              data: null,
              audio_text: this.state.trans,
              duration: 0,
            };
            if (this.props.testMode) {
              this.props.nextQuestion(data_to_send);
            } else {
              this.props.submit(data_to_send, true);
              this.props.showResult();
            }
          })
        });
    }
  };

  setTrans = (a) => {
    if (this.state.trans != a) {
      this.setState({ trans: a });
    }
  };

  submitData = (override = null) => {
    // override: optional object e.g. { data: null, audio_text: '', duration: 0 }
    const payload = override || {
      data: this.state.file || null,
      audio_text: this.state.trans || "",
      duration: this.state.duration || 0,
    };

    if (this.props.testMode) {
      this.props.nextQuestion(payload);
    } else {
      this.props.submit(payload, true);
      this.props.showResult();
    }
  };


  stop = () => {
    console.log("Stop of NEW -> Describe Image");
    if(!this.props.testMode){
      this.props.setIsStopped(true)
    }
    this.setState({ stopInProgress: true });
    if (!this.state.isBlocked && this.state.isRecording) {
      Mp3Recorder.stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          if (!blob || blob.size === 0) {
            console.warn("⚠️ Empty blob – skipping upload");
            // mark processed and submit empty audio so flow continues
            this.setState(
              {
                isRecording: false,
                blobURL: "",
                recordCount: 100,
                recordingProcessed: true,
                stopInProgress: false,
                saveTranscript: false,
                skip: false
              },
              () => {
                // if there's no audio, send empty payload so navigation continues
                this.submitData({ data: null, audio_text: this.state.trans || "", duration: 0 });
              }
            );
            SpeechRecognition.stopListening();
            return;
          }

          // if (this.state.blobURL) {
          //   URL.revokeObjectURL(this.state.blobURL);
          //   this.state.blobURL = "";
          // }
          this.revokeBlobURL();

          // let duration = await getBlobDuration(blob);
          // let file = new File(
          //   [blob],
          //   "noname1" + this.state.questionId + ".mp3",
          //   { type: blob.type }
          // );
          const duration = await getDuration(blob);
          const file = await getFile(blob, buffer,"noname1" + this.state.questionId + ".mp3");
          const blobURL = await getBlobURL(blob, file);

          this.setState(
            {
              newblobURL: blobURL,
              isRecording: false,
              recordCount: 100,
              file,
              saveTranscript: true,            // trigger SpeechToText
              duration,
              stopInProgress: false,
              recordingProcessed: true,       // indicates audio ready
              soundStatus: false,
              skip: false
            },
            () => {
              // If transcript already exists (rare), submit immediately.
              if (this.state.trans && this.state.trans.length > 0) {
                this.submitData();
              }
              // Otherwise, wait for setTranscript() to call submitData()
            }
          );

          SpeechRecognition.stopListening();
        })
        .catch((e) => {
          console.log("stop error:", e);
          // ensure flow continues with empty audio
          this.setState(
            {
              isRecording: false,
              blobURL: "",
              recordCount: 0,
              recordingProcessed: true,
              stopInProgress: false,
              saveTranscript: false,
            },
            () => {
              this.submitData({ data: null, audio_text: this.state.trans || "", duration: 0 });
            }
          );
          SpeechRecognition.stopListening();
        });
    }
  };

  stopTest = async () => {
    // Working for Mock Test,
    console.log("stop test called");

    if(this.state.isProcessing) return;
    if (!this.state.isBlocked && this.state.isRecording) {
      this.setState({ isProcessing: true });
      Mp3Recorder.stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          if (!blob || blob.size === 0) {
            console.warn("⚠️");
            // this.setState(
            //   {
            //     isRecording: false,
            //     blobURL: "",
            //     recordCount: 0,
            //     stopInProgress: false,
            //     recordingProcessed: true,
            //     saveTranscript: false,
            //   },
            //   () => {
            //     this.submitData({ data: null, audio_text: this.state.trans || "", duration: 0 });
            //   }
            // );
            this.setState(
              {
                isRecording: false,
                blobURL: "",
                recordCount: 0,
                stopInProgress: false,
                recordingProcessed: true,
                saveTranscript: false,
                isProcessing:false
              }
            );
            SpeechRecognition.stopListening();
            return;
          }

          // if (this.state.blobURL) {
          //   URL.revokeObjectURL(this.state.blobURL);
          //   this.state.blobURL = "";
          // }
          this.revokeBlobURL();
          // let duration = await getBlobDuration(blob);
          // let file = new File([blob], "noname1.mp3", { type: blob.type });

          const duration = await getDuration(blob);
          const file = await getFile(blob, buffer,"noname1.mp3");
          const blobURL = await getBlobURL(blob, file); 
          SpeechRecognition.stopListening();

          // this.setState(
          //   {
          //     saveTranscript: true,
          //     file,
          //     duration,
          //     stopInProgress: false,
          //     recordingProcessed: true,
          //   },
          //   () => {
          //     // If transcript already present, submit; otherwise setTranscript() will submit on arrival.
          //     if (this.state.trans && this.state.trans.length > 0) {
          //       this.submitData();
          //     }
          //   }
          // );

          this.setState({
              saveTranscript: true,
              file,
              duration,
              stopInProgress: false,
              recordingProcessed: true,
              isProcessing: false
              // blobURL,
              // isRecording:false,
              // recordCount:100
            });
        })
        .catch((e) => {
          console.log("stopTest error:", e);
          console.log("inside stoptest DI");

          // this.setState(
          //   {
          //     isRecording: false,
          //     blobURL: "",
          //     recordCount: 0,
          //     stopInProgress: false,
          //     recordingProcessed: true,
          //     saveTranscript: false,
          //   },
          //   () => {
          //     this.submitData({ data: null, audio_text: this.state.trans || "", duration: 0 });
          //   }
          // );
          this.setState(
            {
              isRecording: false,
              blobURL: "",
              recordCount: 0,
              stopInProgress: false,
              recordingProcessed: true,
              saveTranscript: false,
              isProcessing: false
            }
          );
          SpeechRecognition.stopListening();
        });
    } else {
      // not recording and not processed: submit current available data (may be null)
      if(!this.state.isProcessing){
        this.setState({ isProcessing: true });
        this.submitData();
        this.setState({ isProcessing: false });
      }
    }
  };


  updateCorrect = () => {
    this.props.submit({
      data: "",
      audio_text: "",
      duration: this.state.duration,
    });
    this.setState({ correctFlag: false });
  };

  skip = () => {
    // Prevent multiple clicks
    if (this.state.skipInProgress || this.state.isRecording) {
      console.log('Skip already in progress or recording');
      return;
    }
    this.setState({
      skip: false,
      soundStatus: false,
      blobURL: "",
      secondCount: 0,
      recordCount: 0,
      recordingProcessed: false,
      practiceStarted: !this.props.showStartPractice,
    });

    clearInterval(this.state.intervalId);
    this.start();
    var recordId = setInterval(this.timerRecord, 1000);
    this.setState({ recordId: recordId, secondCount: 0 });
  };

  timer = () => {
    if (this.state.secondCount === 1) {
      clearInterval(this.state.intervalId);

      // if(!this.state.isRecording){
      //   this.handleSongFinishedPlaying();
      // }
      // else {
      this.start();
      // }
      var recordId = setInterval(this.timerRecord, 1000);
      this.setState({ recordId: recordId, secondCount: 0 });
      return
    }
    this.setState({ secondCount: this.state.secondCount - 1 });
  };

  startManualRecord = () => {
    clearInterval(this.state.intervalId);

    // if(!this.state.isRecording){
    //   this.handleSongFinishedPlaying();
    // }
    // else {
    this.start();
    // }
    var recordId = setInterval(this.timerRecord, 1000);
    this.setState({ recordId: recordId, secondCount: 0 });
  }

  timerRecord = () => {
    if (this.state.recordCount === 40) {
      clearInterval(this.state.recordId);
      // if (!this.props.testMode) {
      // }
      this.stop();
      SpeechRecognition.stopListening();
    }
    this.setState({ recordCount: this.state.recordCount + 1 });
  };

  componentWillUnmount = () => {
    this.cleanupResources();
  };

  cleanupResources = () => {
    // Clear any running intervals
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
      console.log("Interval for question countdown cleared.");
    }
    if (this.state.recordId) {
      clearInterval(this.state.recordId);
      console.log("Interval for recording countdown cleared.");
    }

    // Revoke blob URL if exists
    // if (this.state.blobURL) {
    //   URL.revokeObjectURL(this.state.blobURL);
    //   console.log("Revoked blob URL to free memory.");
    // }
    this.revokeBlobURL();

  };

  handleImageLoaded = () => {
    this.setState({ imageLoaded: true });
  };

  setSaveTranscript = (status) => {
    this.setState({ saveTranscript: status });
  };



  setTranscript = (transcript) => {
    console.log("Transcript====", transcript);

    this.setState(
      {
        trans: transcript,
        saveTranscript: false,
      },
      () => {
        // Only submit if recording is already processed (audio ready)
        if (this.state.recordingProcessed) {
          this.submitData();
        } else {
          // recording not ready yet: setTranscript will just store transcript and
          // submit later when recordingProcessed becomes true (stop()/stopTest()).
          console.log("Transcript saved, waiting for audio to be processed before submitting.");
        }
      }
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.stopRecording && !prevProps.stopRecording) {
      this.stopTest();
    }
  }

  render() {
    let question = "";
    // console.log(this.state.skip, "Here is the skip");
    // if (!this.state.imageLoaded) {
    //   const img = new Image();
    //   img.src = s3base + this.props.data.media_link;
    //   if (img.complete) {
    //     var intervalId = setInterval(this.timer, 1000);
    //     this.setState({intervalId: intervalId,reset:false,imageLoaded:true});

    //   }
    // }
    if (this.props.restart) {
      this.setState({ skip: true });
      this.props.restartQue();
    }
    // if (this.props.stopRecording) {
    //   this.stopTest();
    // }
    if (this.props.data) {
      question = this.props.data.question;
      if (this.state.correctFlag) {
        this.updateCorrect();
      }
    }
    if (this.state.reset) {
      /*var intervalId = setInterval(this.timer, 1000);
    this.setState({intervalId: intervalId,reset:false});*/
    }
    if (this.state.isBlocked) {
      return <NoMicrophone />;
    }

    // console.log("this.state.lburl", this.state.blobURL);

    return (
      <>
        {/*<Dictaphone setTrans={this.setTrans} status={this.state.reset || this.state.isRecording} />*/}

        <SpeechToText
          saveTranscript={this.state.saveTranscript}
          setTranscript={this.setTranscript}
        />

        <Col xs={12}>
          <h4 className="infoText"></h4>
        </Col>
        <Col xs={12}>
          <Row>
            <Col lg={6}>
              {/*{!this.state.imageLoaded && <div style={{margin:'145px'}}>Loading...</div>}
              {this.state.imageLoaded && this.props.data && <img alt="media-link" width="500" onLoad={this.handleImageLoaded} src={s3base + this.props.data.media_link} />}*/}

              <img
                alt="media-link"
                width="500"
                onLoad={this.handleImageLoaded}
                src={`data:image/png;base64, ${this.props.data.image}`}
              />
            </Col>
            <div className="col-lg-6 p-0 text-center">
              {!this.props.resultMode && (
                <div className="audio-box">
                  <h4>Recorded Answer</h4>
                   {/* Start Practice Button - Shows only when needed */}
                  {this.props.showStartPractice && (
                    <div className="stop-btn mb-3">
                      <Button
                        color="primary"
                        onClick={this.startPractice}
                        size="lg"
                      >
                        Start Practice
                      </Button>
                    </div>
                  )}
                  {this.state.practiceStarted && (
                    <>
                  <p>
                    <strong>Current status:</strong>
                  </p>
                  {/* <p>
                    {this.state.blobURL === "" && this.state.isRecording
                      ? "Recording started"
                      : `Recording starts in ${this.state.secondCount} seconds`}
                  </p> */}
                   {this.props.testMode ?  <p>
  {this.state.isRecording 
    ? "Recording started" 
    : this.state.blobURL 
      ? "Recording Finished" 
      : `Recording starts in ${this.state.secondCount} seconds`
  }
</p> :  <p>
  {this.state.isRecording 
    ? "Recording started" 
    : this.state.newblobURL 
      ? "Recording Finished" 
      : `Recording starts in ${this.state.secondCount} seconds`
  }
</p>}
                  {!this.props.testMode &&
                    this.state.blobURL === "" &&
                    !this.state.isRecording &&
                    this.state.skip && (
                      <div className="stop-btn">
                        <Button color="success" onClick={this.skip} size="sm">
                          Skip
                        </Button>
                      </div>
                    )}
                  {/* <Button color="success" onClick={this.startManualRecord} size="sm">
                          start recording
                        </Button> */}
                  <hr></hr>
                  {/*this.state.isRecording && "Recording Time : "+this.state.recordCount*/}
                  {!this.props.testMode &&
                    this.state.isRecording &&
                    (
                      <div className="stop-btn">
                        <Button color="success" disabled={this.state.stopInProgress} onClick={this.stop} size="sm">
                          Stop
                        </Button>
                      </div>
                    )}
                  <hr></hr>
                  <Progress color="info" value={this.state.recordCount * 2.5} />
                  <div className="audo-line">
                    <span className="progress-bar-fill-Read intro"></span>
                  </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </Row>

          <Col xs={12}>
            {this.state.newblobURL && !this.props.testMode && (
              <>
                {/* <audio src={this.state.blobURL} controls="controls" /> */}

                <audio src={this.state.newblobURL} controls="controls" />
              </>
            )}
          </Col>
        </Col>

        <Col xs={12}>
          <h5>{question}</h5>
        </Col>

        {!this.props.resultMode && this.state.soundStatus && (
          <Sound
            url={`${s3base}/ptedata/ptemedia/beep.mp3`}
            playStatus={Sound.status.PLAYING}
            onFinishedPlaying={this.handleSongFinishedPlaying}
            onError={(errorCode, description) => {
              // FIX: Handle audio errors
              console.error("Sound playback error:", errorCode, description);
              // Optionally skip to next question or show error
            }}
          />
        )}
      </>
    );
  }
}
export default DescribeImage;

